import { Grid } from '@material-ui/core';
import { TipoCargosChapa } from 'helpers/enums/TipoCargosChapa';
import translation from 'locales/translation';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { IAssembleiasAssessorItens } from 'store/modules/AssembleiasAssessorReducer';
import { IAssembleiaAssociadoPautaOpcao } from 'store/modules/AssembleiasAssociadoReducer';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from '../../../../store/modules/ModalsActionTypes';
import { IModalProps } from '../../../../store/modules/ModalsReducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';
import { useStyles } from './styles';

export interface IPautaEleicaoGenericProps extends IGenericModalProps {
  item: IAssembleiaAssociadoPautaOpcao | IAssembleiasAssessorItens;
  key: string;
}

export interface IPautaEleicao extends IModalProps {
  genericProps: IPautaEleicaoGenericProps;
  modalsActionsClose: (key: string) => ModalsActionsClose;
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      modalsActionsClose,
    },
    dispatch
  );

const PautaEleicao = ({ genericProps, open }: IPautaEleicao) => {
  const classes = useStyles();
  const dispatchAction = useDispatch();

  const toClose = (): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  };

  const getPresidente = () => {
    const presidente = genericProps.item.representantesChapa.find(
      (it) => it.nomeCargo === TipoCargosChapa.Presidente
    );

    return presidente ? (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.subTitle}>
          <b>{translation.PautaEleicaoModal.presidente}</b>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.itemEleicao}
        >
          <div className={classes.itemText}>{presidente.associado}</div>
        </Grid>
      </Grid>
    ) : null;
  };

  const getVice = () => {
    const vices = genericProps.item.representantesChapa
      .filter((it) => it.nomeCargo === TipoCargosChapa.Vice_Presidente)
      .map((it) => ({ nome: it.associado, id: it.idRepresentanteChapa }));

    return vices.length > 0 ? (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.subTitle}>
          <b>{translation.PautaEleicaoModal.vice}</b>
        </Grid>
        {vices.map((it) => {
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.itemEleicao}
              key={it.id}
            >
              <div className={classes.itemText}>{it.nome}</div>
            </Grid>
          );
        })}
      </Grid>
    ) : null;
  };

  const getConselheiros = () => {
    const conselheiros = genericProps.item.representantesChapa
      .filter((it) => it.nomeCargo === TipoCargosChapa.Conselheiro)
      .map((it) => ({ nome: it.associado, id: it.idRepresentanteChapa }));

    return conselheiros.length > 0 ? (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.subTitle}>
          <b>{translation.PautaEleicaoModal.conselheiro}</b>
        </Grid>
        {conselheiros.map((it) => {
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.itemEleicao}
              key={it.id}
            >
              <div className={classes.itemText}>{it.nome}</div>
            </Grid>
          );
        })}
      </Grid>
    ) : null;
  };

  const getConselheirosEfetivos = () => {
    const conselheirosEfetivos = genericProps.item.representantesChapa
      .filter((it) => it.nomeCargo === TipoCargosChapa.Conselheiro_Efetivo)
      .map((it) => ({ nome: it.associado, id: it.idRepresentanteChapa }));

    return conselheirosEfetivos.length > 0 ? (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.subTitle}>
          <b>{translation.PautaEleicaoModal.conselheiroEfetivo}</b>
        </Grid>
        {conselheirosEfetivos.map((it) => {
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.itemEleicao}
              key={it.id}
            >
              <div className={classes.itemText}>{it.nome}</div>
            </Grid>
          );
        })}
      </Grid>
    ) : null;
  };

  const getConselheirosSuplentes = () => {
    const conselheirosSuplentes = genericProps.item.representantesChapa
      .filter((it) => it.nomeCargo === TipoCargosChapa.Conselheiro_Suplente)
      .map((it) => ({ nome: it.associado, id: it.idRepresentanteChapa }));

    return conselheirosSuplentes.length > 0 ? (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.subTitle}>
          <b>{translation.PautaEleicaoModal.conselheiroSuplente}</b>
        </Grid>
        {conselheirosSuplentes.map((it) => {
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.itemEleicao}
              key={it.id}
            >
              <div className={classes.itemText}>{it.nome}</div>
            </Grid>
          );
        })}
      </Grid>
    ) : null;
  };

  return (
    <GenericModal
      open={open ?? false}
      title={`${translation.PautaEleicaoModal.title} ${genericProps.item.descricao}`}
      content={
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {getPresidente()}
            {getVice()}
            {getConselheiros()}
            {getConselheirosEfetivos()}
            {getConselheirosSuplentes()}
          </Grid>
        </Grid>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  );
};

export default connect(null, mapDispatchToProps)(PautaEleicao);
